module.exports = function() {
  return new Worker(__webpack_public_path__ + "ab44fca5799f4e2996d6.worker.js");
};